<template>
    <div>
        <section v-if="!image.url" class="section">
            <div class="container">
                <div class="file is-centered">
                    <label class="file-label">
                        <input
                            class="file-input"
                            type="file"
                            accept="image/*"
                            input="handleImage($event.target.files)"
                            @change="handleImage($event.target.files)"
                        />
                        <span class="file-cta">
                            <span
                                v-t="'creation.select_file'"
                                class="file-label"
                            />
                        </span>
                    </label>
                </div>
            </div>
        </section>
        <section class="section pt-6 mt-1">
            <div v-if="image.url" class="container">
                <div class="columns is-multiline">
                    <div class="column has-min-width-200 has-actions-inside">
                        <div>
                            <figure class="image">
                                <img :src="image | mediaSource" />
                            </figure>
                            <button
                                class="lb-delete-media"
                                @click.stop="removeImage()"
                            >
                                <span class="icon is-small">
                                    <i class="fas fa-trash" />
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import _ from 'underscore';
import { upload } from '@/services/API';
export default {
    name: 'InputImage',
    filters: {
        mediaSource(media) {
            if (typeof media === 'string') return media;
            if (typeof media === 'object') {
                if (_.isArray(media)) return media[0].url;
                else return media.url;
            }
        },
    },
    model: {
        prop: 'sourceImage',
    },
    props: {
        fromClipboard: { type: Boolean, default: false },
        sourceImage: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            colors: [],
            image: this.sourceImage || {},
        };
    },
    computed: {
        clipboardContent() {
            return this.$store.getters.clipboardContent;
        },
    },
    watch: {
        clipboardContent() {
            if (this.clipboardContent && this.clipboardContent.length) {
                _.each(this.clipboardContent, (image, i) => {
                    if (image instanceof File) {
                        this.handleImage([image]);
                    } else if (image.type.indexOf('image') !== -1) {
                        this.handleImage([image.getAsFile()]);
                    }
                });
                this.$store.dispatch('setClipboardContent', undefined);
            }
        },
    },
    mounted() {
        if (this.clipboardContent && this.clipboardContent.length) {
            _.each(this.clipboardContent, (image) => {
                if (image.type.indexOf('image') !== -1) {
                    if (image instanceof File) {
                        this.handleImage([image]);
                    } else {
                        this.handleImage([image.getAsFile()]);
                    }
                }
            });
        }
    },
    methods: {
        async handleImage(files) {
            console.log('in handle');
            if (files.length == 0) {
                return;
            }
            this.$emit('uploading');
            let response = await upload(`images`, files).catch(() => {
                return this.$emit('error');
            });
            if (response.data) {
                this.image = response.data.images[0];
                this.$emit('input', this.image);
            }
        },
        removeImage() {
            this.image = {};
        },
    },
};
</script>

<style scoped>
.has-min-width-200 {
    min-width: 200px;
    padding: 0;
    margin: 5px;
}
.has-actions-inside {
    position: relative;
}
.is-fixed-on-top-content {
    position: absolute;
    top: 60px;
    width: 100%;
    margin: 0 auto;
    z-index: +1;
    padding-top: 0rem;
    padding-right: 3rem;
    padding-left: 0;
}
.is-fixed-on-top-content .container {
    margin: 0 auto;
    background-color: #ffffff;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.is-fixed-on-top-content .file {
    margin-bottom: 1rem;
    margin-top: 1rem;
}
</style>
